const routes = [
    {
        path: "/levels",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "level_index"
        }
    }
];

export default routes;
